import { Component, type ErrorInfo, type ReactNode } from "react";
import * as debugCapture from "../lib/debugCapture";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/** Task 9.6 — a render-time crash (e.g. the MCPView `tools[s.id].length`
 * throw fixed elsewhere in this phase) used to take down the whole app with
 * a blank white screen. This renders a fallback instead, with a way back. */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info.componentStack);
    debugCapture.recordUIError("ErrorBoundary", error.message, error.stack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary" role="alert">
          <h2>Something went wrong</h2>
          <p className="dim">{this.state.error.message}</p>
          <button
            className="btn btn-primary"
            onClick={() => {
              this.setState({ error: null });
              window.location.assign("/");
            }}
          >
            Back to Chat
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
